module.exports = __webpack_public_path__ + "img/je.6709730b.svg";